<template>
  <div class="imagebox">
    <div class="maintitle">
      <span>{{ item.title }}</span>
    </div>
    <div
      v-if="item.url != 'Communications'"
      @click="navigateTo('fromImage')"
      class="img"
      :style="{
        backgroundImage:
          'url(' + require('../assets/' + item.img_name + '.png') + ')',
      }"
    ></div>
    <div v-else>
      <communicationsImage
        v-if="isMobile"
        :isHeader="false"
      ></communicationsImage>
      <div
        v-else
        @click="navigateTo('fromImage')"
        class="img"
        :style="{
          backgroundImage:
            'url(' + require('../assets/' + item.img_name + '.png') + ')',
        }"
      ></div>
    </div>
    <v-btn class="generic-button" @click="navigateTo()">
      {{ item.btn_label }}
    </v-btn>
    <div class="description">
      <span>{{ item.description }}</span>
    </div>
    <div class="link" v-if="item.showLink">
      <a :href="newsletter_url" target="_blank">{{ $t("Home.Newsletter") }}</a>
    </div>
  </div>
</template>
<style>
/********* image-box *********/

.imagebox {
  position: relative;
}

.imagebox.maintitle {
  line-height: 90px;
  font: normal normal bold 30px/35px Roboto;
  color: #5d6367;
}

.imagebox .img {
  margin-top: 49px;
  height: 250px;
  position: relative;
  border-radius: 40px;
  box-shadow: 11px 13px 14px #6f767ab3;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}

.imagebox .description {
  text-align: center;
  padding-top: 27px;
  padding-left: 100px;
  padding-right: 100px;
  font: normal normal bold 20px/24px Lato;
  letter-spacing: 0px;
  color: #6f767a;
}

.imagebox .generic-button {
  position: absolute;
  top: 270px;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 5px 5px 15px #ffffff;
}

@media (max-width: 600px) {
  .imagebox {
    height: 122px;
    border: 4px solid #707070;
    border-radius: 20px;
    background-color: white;
    box-shadow: 5px 5px 10px #6f767ab3;
  }

  .imagebox .img {
    margin-top: 0px;
    width: 95px;
    height: 95px;
    border-radius: 0px;
    box-shadow: none;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
  }

  .imagebox .description {
    display: none;
  }

  .imagebox .generic-button {
    display: none;
  }

  .imagebox .maintitle {
    font: normal normal bold 15px/18px Lato !important;
    text-transform: uppercase;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    bottom: 16px;
  }

  .imagebox .link {
    display: none;
  }
}
</style>
<script>
import { Trans } from "@/plugins/Translation";
import router from "@/router/index.js";
// import communicationsImage from "../components/communicationsImage.vue";
import Communications from "../views/Communications.vue";

export default {
  components: {
    // communicationsImage,
    Communications,
  },

  props: {
    type: "",
    item: {
      title: String,
      img_name: String,
      btn_label: String,
      description: String,
      url: String,
      showLink: Boolean,
    },
  },

  data() {
    return {
      newsletter_url: process.env.VUE_APP_NEWSLETTER,
      isMobile: false,
    };
  },

  created() {
    window.addEventListener("resize", this.myEventHandler);
    this.setIsMobile();
  },

  methods: {
    navigateTo(source) {
      if (source == "fromImage" && !this.isMobile) return;

      this.news_url = "";
      if (this.item.url == "Quotations") {
        router.push({ name: "quotations" });
      }
      if (this.item.url == "Communications") {
        router.push({ name: "communications" });
      }
      if (this.item.url == "News") {
        window.open(process.env.VUE_APP_NEWS, "_blank");
      }
    },
    myEventHandler(e) {
      this.setIsMobile();
    },
    setIsMobile() {
      this.isMobile = window.innerWidth < this.$genericClass.mobileMaxWidth();
    },
  },
};
</script>